import { PrimaryButton } from '@geneo2-web/shared-ui';
import { Box, Typography } from '@mui/material';
import { clearOngoingJourneysApi } from '../api/module';
import { useAppDispatch } from '../../../reduxStore/reduxHooks';
import { setToastInfo } from '../../Home/reducer/homeDashboard.slice';
import { HOME } from '../../../routeHandling/RoutesNomenclature';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

const PalResetUser = () => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const onYesClick = async () => {
    try {
      setIsLoading(true);
      await clearOngoingJourneysApi();
      dispatch(
        setToastInfo({
          label: 'PAL Journey reset successfully.',
          variant: 'success',
          open: true,
        })
      );
      navigate(HOME);
    } catch (err) {
      console.error(err);
      dispatch(
        setToastInfo({
          label: 'Failed to reset the user PAL journey.',
          variant: 'error',
          open: true,
        })
      );
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Box sx={{ p: '15px', textAlign: 'center' }}>
      <Typography variant="h2" sx={{ my: '15px' }}>
        Are you sure you want to reset your PAL Journey?
      </Typography>
      <PrimaryButton onClick={onYesClick} disabled={isLoading}>
        Yes
      </PrimaryButton>
    </Box>
  );
};

export default PalResetUser;
